import React, { useEffect, useState } from "react";
import { Table, Tag, Select } from "antd";
import Routes from "../../api/contact";

const Contact = () => {
  const [contacts, setContacts] = useState([]);

  const request = async () => {
    try {
      const res = await Routes.getContacts();
      setContacts(res.data);
      // console.log(contacts);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  const passContact = async (id) => {
    const res = await Routes.setComplete(id);
    if (res.status === 200) {
      let array = contacts?.map((val) =>
        val?._id == id ? { ...val, status: "pass" } : val
      );
      setContacts(array);
    }
  };
  useEffect(() => {
    request();
  }, []);

  const columns = [
    {
      key: "1",
      dataIndex: "fullName",
      title: "Name",
      render: (val, record) => <div>{record?.name}</div>,
    },
    {
      key: "2",
      dataIndex: "email",
      title: "Email",
      render: (val, record) => <div>{record?.email}</div>,
    },
    {
      key: "3",
      dataIndex: "businessName",
      title: "Business Name",
      render: (val, record) => <div>{record?.business_name}</div>,
    },
    {
      key: "4",
      dataIndex: "businessIncurence",
      title: "Business Incurance",
      render: (val, record) => <div>{record?.business_insurance}</div>,
    },
    {
      key: "5",
      dataIndex: "phoneNumber",
      title: "Phone Number",
      render: (val, record) => <div>{record?.number}</div>,
    },
    {
      key: "6",
      dataIndex: "ubi",
      title: "UBI",
      render: (val, record) => <div>{record?.ubl}</div>,
    },
    {
      key: "7",
      dataIndex: "status",
      title: "Status",
      render: (val, record) => (
        <div>
          {record?.status === "pass" ? (
            <Tag color="green">Approved</Tag>
          ) : (
            <Select
              value={record?.status || "pending"} // Control the value based on record.status
              onChange={(e) => {
                if (e === "complete") {
                  passContact(record?._id);
                }
              }}
            >
              <Select.Option value="pending">Pending</Select.Option>
              <Select.Option value="complete">Approve</Select.Option>
            </Select>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="review_table">
      <Table columns={columns} dataSource={contacts} rowKey="id" />
    </div>
  );
};

export default Contact;
